import { useTranslate } from "ra-core";
import { ArrayInput } from "@/components/admin/array-input";
import { SimpleFormIterator } from "@/components/admin/simple-form-iterator";
import { TextInput } from "@/components/admin/text-input";
import { Card, CardContent } from "@/components/ui/card";

/** Settings section: the shared email templates of the compose window. */
export const SettingsEmailTemplates = () => {
  const translate = useTranslate();
  return (
    <Card id="email-templates">
      <CardContent className="space-y-4">
        <h2 className="text-xl font-semibold text-muted-foreground">
          {translate("crm.settings.email_templates.title")}
        </h2>
        <p className="text-sm text-muted-foreground">
          {translate("crm.settings.email_templates.help")}
        </p>
        <ArrayInput source="emailTemplates" label={false} helperText={false}>
          <SimpleFormIterator disableReordering disableClear fullWidth>
            <TextInput
              source="name"
              label="crm.settings.email_templates.name"
              helperText={false}
            />
            <TextInput
              source="subject"
              label="crm.settings.email_templates.subject"
              helperText={false}
            />
            <TextInput
              source="body"
              label="crm.settings.email_templates.body"
              multiline
              helperText={false}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </CardContent>
    </Card>
  );
};
